import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { IntegrationSettings } from '@/components/settings/integration-settings';
import { Wallet, Sparkles } from 'lucide-react';

export function IntegrationsPage() {
  const [activeTab, setActiveTab] = useState('expense');

  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Integrations</h1>
          <p className="text-muted-foreground mt-1 text-sm md:text-base">
            Configure your system integrations
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="expense" className="flex items-center gap-2">
            <Wallet className="h-4 w-4" />
            Expense
          </TabsTrigger>
          <TabsTrigger value="coming-soon" className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            More Products Coming Soon...
          </TabsTrigger>
        </TabsList>

        <TabsContent value="expense" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Expense Integration</CardTitle>
              <CardDescription>
                Configure your expense management system integration settings
              </CardDescription>
            </CardHeader>
            <CardContent>
              <IntegrationSettings />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="coming-soon" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>More Products Coming Soon</CardTitle>
              <CardDescription>
                We're working on integrations with more products
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-col items-center justify-center py-12 gap-4">
                <Sparkles className="h-16 w-16 text-muted-foreground" />
                <p className="text-lg font-medium text-center">Exciting integrations are on the way!</p>
                <p className="text-muted-foreground text-center max-w-md">
                  We're constantly expanding our integration capabilities. Check back soon for new product integrations.
                </p>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
